<style scoped>

  .ui.segment {
    min-height: 200px;
  }

  .settleDate {
    max-width: 90px;
  }

</style>

<template>
  
  <div>

    <div class="ui large breadcrumb">      
      <a class="clickable" @click="$historyBack()">
        <i class="reply icon m-r-5"></i>
        {{ $route.query.historyBack && $route.query.historyBack == "true" ? "Voltar" : "Títulos a Pagar" }}
      </a>
      <i class="right chevron icon divider"></i>
      <div class="section">
        <strong>Visualizar Título a Pagar</strong>
      </div>
    </div>

    <div class="ui divider"></div>

    <div v-if="loading"><i class="spinner circle loading blue icon"></i> Carregando ...</div>

    <div v-else class="animated fadeIn">        

      <div class="m-b-20">
        <button class="ui button" v-if="payable.balance == payable.value" @click="$refs.formModal.update(payable)">
          <i class="edit grey icon"></i> Alterar
        </button>
        <button v-if="payable.balance" class="ui button m-l-10" @click="$refs.settleModal.create(payable)">
          <i class="check square outline green icon"></i> Baixar
        </button>
      </div>

      <div class="ui grid">
        
        <div class="sixteen wide column">
          <div class="ui segment">
            <h4 class="ui dividing header">
              Dados do Título
              <span v-if="payable.invoiceId" class="ui teal label clickable" @click="onShowInvoice()">
                Fechamento <div class="detail">{{ payable.invoiceId }}</div>
              </span>
            </h4>
            <div class="ui form">
              <div class="fields"> 
                <div class="two wide field">
                  <label class="form-label">Número</label>                   
                  {{ payable.id }}
                </div>
                <div class="three wide field">
                  <label class="form-label">Status</label>                   
                  <i :class="status.icon"></i>
                  {{ status.description }}
                </div>
                <div class="three wide field">
                  <label class="form-label">Tipo</label>                   
                  <i :class="type.icon"></i>
                  {{ type.description }}
                </div>
                <div class="three wide field">
                  <label class="form-label">Natureza</label>                   
                  {{ payable.nature.description }}
                </div>
                <div class="five wide field">
                  <label class="form-label">Emissão</label>
                  {{ $formatDate(payable.date) }}
                </div>
              </div>
              <div class="fields">                
                <div class="five wide field">
                  <label class="form-label">Fornecedor</label>                   
                  {{ payable.supplier.name }}
                </div>                
                <div class="three wide field">
                  <label class="form-label">Vencimento</label>
                  {{ $formatDate(payable.dueDate) }}
                </div>
                <div class="three wide field">
                  <label class="form-label">Venc. Real</label>
                  {{ $formatDate(payable.realDueDate) }}
                </div>
                <div class="three wide field">
                  <label class="form-label">Valor</label>
                  R$ {{ $formatCurrency(payable.value) }}
                </div>
                <div class="two wide field">
                  <label class="form-label">Saldo</label>
                  R$ {{ $formatCurrency(payable.balance) }}
                </div>
              </div>
              <div v-if="payable.comments" class="fields">
                <div class="sixteen wide field">
                  <label class="form-label">Observações</label>                   
                  {{ payable.comments }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="sixteen wide column">
          <div class="ui segment" :class="{ loading: updatingSettles }">
            <h4 class="ui dividing header">Baixas</h4>
            <div v-if="payable.settles.length" class="m-t-20">
              <table class="ui celled selectable tablet stackable table">
                <thead v-if="$isDesktop">
                  <tr>
                    <th>Data</th>
                    <th>Valor da Baixa</th>
                    <th>Créditos</th>
                    <th>Total da Baixa</th>
                    <th>Usuário</th>
                    <th></th>
                  </tr>  
                </thead>
                <tbody>
                  <tr v-for="(settle, index) in payable.settles">
                    <td class="settleDate">
                      <strong class="mobile-only">Data: </strong> 
                      {{ $formatDate(settle.date) }}
                      <div v-if="settle.refDate != settle.date" class="ui small label m-l-5">
                        Ref. <span class="detail">{{ $formatDate(settle.refDate) }}</span>
                      </div>
                    </td>
                    <td>
                      <strong class="mobile-only">Valor da Baixa: </strong> R$ {{ $formatCurrency(settle.value) }}
                    </td>
                    <td>
                      <strong class="mobile-only">Créditos: </strong> R$ {{ $formatCurrency(settle.credits) }}
                    </td>
                    <td @click="onSettleTotalValueClick(settle)">
                      <strong class="mobile-only">Total da Baixa: </strong> 
                      R$ {{ $formatCurrency(settle.value + settle.credits) }}
                      <div v-if="settle.payableCompensationId" class="ui teal label m-l-5 clickable">
                        Compensação de créditos
                        <div class="detail">{{ settle.payableCompensationId }}</div>
                      </div>
                    </td>                    
                    <td>
                      <strong class="mobile-only">Usuário: </strong> {{ settle.user.name }}
                    </td>                    
                    <td style="width: 50px;">
                      <button class="ui small icon button" @click="onRemoveSettle(index)">
                        <i class="times icon"></i>
                      </button>
                    </td>
                  </tr>                
                </tbody>              
              </table>
            </div>
            <p v-else class="grey text m-t-15">
              <i class="info circle icon"></i> Esse título ainda não sofreu baixas
            </p>
          </div>
        </div>

      </div>

    </div>  

    <form-modal ref="formModal" @onSave="loadPayable()" @onRemove="$historyBack()" />

    <settle-modal ref="settleModal" :autoFill="true" @onConfirm="onConfirmSettle" />

    <compensation-modal ref="compensationModal" />

    <yes-no-modal ref="settleRemovalModal" danger="true" :htmlMessage="settleRemovalMessage"  @onYes="onConfirmSettleRemoval()" />

  </div>

</template>  

<script>

  import PayableService from "@/services/payable-service"
  import onlyFinancial from "@/mixins/only-financial"
  import YesNoModal from "@/components/yes-no-modal"
  import FormModal from "./form-modal"
  import CompensationModal from "./compensation-modal"
  import SettleModal from "./settles/value-modal"

  export default {
    
    name: "ShowPayablePage",

    mixins: [onlyFinancial],

    data() {
      return {
        loading: true,
        updatingSettles: false,
        payable: null,
        status: null,
        type: null,
        selectedSettleIndex: -1,
        service: new PayableService(),
      }
    },

    components: {
      FormModal,
      CompensationModal,
      SettleModal,
      YesNoModal,
    },

    created() {
      this.loadPayable()
    },

    computed: {
      
      settleRemovalMessage() {

        if (this.selectedSettleIndex == -1)
          return ""

        let label = ""
        const settle = this.payable.settles[this.selectedSettleIndex]

        if (settle.payableCompensationId) {
          label += `<div class="m-b-15">Essa baixa foi gerada via compensação de créditos. `
          label += `<span class="bold">A exclusão irá estornar também todas as baixas relacionadas.</span></div>`
        }          

        label += `Confirma exclusão da baixa do dia ${this.$formatDate(settle.createdAt)} no valor de R$ ${this.$formatCurrency(settle.value + settle.credits)} ?`

        return label
      },
    },

    methods: {

      async loadPayable() {

        this.loading = true

        try {

          this.payable = await this.service.findById(this.$route.params.id)

          this.status = PayableService.getStatus(this.payable)
          this.type = PayableService.TYPES[this.payable.type]
          
        } catch (error) {

          this.$errorHandler(error)

        } finally {

          this.loading = false
        }
      },

      onShowInvoice() {
        this.$router.push(`/financial/employee-invoices/${this.payable.invoiceId}/show?historyBack=true`)
      },      

      async onConfirmSettle(data) {

        this.updatingSettles = true

        try {

          await this.service.settle(this.payable.id, data)

          this.$reloadDataTables(["payables"])

          this.$msg.success("Baixa realizada com sucesso")

          this.loadPayable()
          
        } catch (error) {
          
          this.$errorHandler(error)
        
        } finally {

          this.updatingSettles = false
        }
      },

      onRemoveSettle(index) {
        this.selectedSettleIndex = index
        this.$refs.settleRemovalModal.show()
      },

      async onConfirmSettleRemoval() {

        this.updatingSettles = true

        try {

          const settle = this.payable.settles[this.selectedSettleIndex]

          await this.service.deleteSettle(this.payable.id, settle.id)

          this.selectedSettleIndex = -1

          this.$reloadDataTables(["payables"])

          this.$msg.success("Baixa excluída com sucesso")

          this.loadPayable()
          
        } catch (error) {
          
          this.$errorHandler(error)
        
        } finally {

          this.updatingSettles = false
        }
      },

      async onSettleTotalValueClick(settle) {

        if (settle.payableCompensationId)
          this.$refs.compensationModal.load(settle.payableCompensationId)
      },
    },
  }
</script>